import { render, staticRenderFns } from "./EntityDocuments.vue?vue&type=template&id=441843d2&"
import script from "./EntityDocuments.vue?vue&type=script&lang=js&"
export * from "./EntityDocuments.vue?vue&type=script&lang=js&"
import style0 from "./EntityDocuments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports